<div class="cx-promotions" *ngIf="promotions">
  <ul *ngFor="let promotion of promotions">
    <li>{{ promotion.description }}</li>
  </ul>
</div>
